/* eslint-disable import/prefer-default-export */

/*
 * @Author: wangshengqiang
 * @Date: 2021-06-10 15:37:28
 * @LastEditTime: 2021-06-10 17:42:49
 * @LastEditors: wangshengqiang
 * @Description: async-validate 自定义验证方法
 */
import { isCard, isEmail, isName, isNumber, certNoTestMap } from './index';

const isEmpty = val => [null, undefined, ''].includes(val);

const isValidateSuccess = ({
  value,
  rule,
  validateFn
}) => {
  return !isEmpty(value) && validateFn(value) || !rule.required && isEmpty(value);
}; // TODO: 通用验证
// const validateMap = {
//   validateEmail: [isEmail, '邮箱格式不正确'],
//   validateName: [isName, '姓名格式不正确'],
//   validateNumber: [isNumber, '格式不正确'],
// };
// const commonValidate = Object.keys(validateMap).reduce((result, key) => {
//   const [validator, msg] = validateMap[key];
//   result[key] = (rule, value, callback) => {
//     // 验证必填/非必填
//     if ((!isEmpty(value) && validator(value)) || (!rule.required && isEmpty(value))) {
//       callback();
//     } else {
//       if (rule.required && isEmpty(value)) {
//         return callback(new Error('请输入'));
//       }
//       callback(new Error(msg));
//     }
//   };
//   return result;
// }, {});
// export default commonValidate;
// 证件号码


export const validateIdCard = async (rule, value, callback, certType) => {
  const valdateCertType = val => {
    if (!certType) {
      return true;
    }

    const fn = certNoTestMap[certType];

    if (typeof fn !== 'function') {
      return true;
    }

    return fn(val);
  };

  const isSuccess = valdateCertType(value);

  if (rule.required && isSuccess || !rule.required) {
    callback();
  } else {
    if (rule.required && isEmpty(value)) {
      return callback(new Error('请输入'));
    }

    callback(new Error('证件号码不正确'));
  }
}; // 邮箱验证

export const validateEmail = (rule, value, callback) => {
  if (isValidateSuccess({
    value,
    rule,
    validateFn: isEmail
  })) {
    callback();
  } else {
    if (rule.required && isEmpty(value)) {
      return callback(new Error('请输入'));
    }

    callback(new Error('邮箱格式不正确'));
  }
}; // 姓名验证

export const validateName = (rule, value, callback) => {
  if (isValidateSuccess({
    value,
    rule,
    validateFn: isName
  })) {
    callback();
  } else {
    if (rule.required && isEmpty(value)) {
      return callback(new Error('请输入'));
    }

    callback(new Error('姓名格式不正确'));
  }
};
export const validateNumber = (rule, value, callback) => {
  if (isValidateSuccess({
    value,
    rule,
    validateFn: isNumber
  })) {
    callback();
  } else {
    if (rule.required && isEmpty(value)) {
      return callback(new Error('请输入'));
    }

    callback(new Error('格式不正确'));
  }
};